import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { LightBox } from '@lion-design/core';
import { actions } from '@Redux/detail/Itineraries';
import { RootState } from '@Redux/detail/store';
import Carousel from './subComponents/Carousel';
import Intro from './subComponents/Intro';
import Poi from './subComponents/Poi';
import styles from './style.module.scss';

const ItineraryDailyLightbox = () => {
    const { lightBoxVisible: visible, Name, ImgMList, Introduction } = useSelector(
        (state: RootState) => state.itinerariesReducer
    );

    const dispatch = useDispatch();

    return (
        <LightBox
            width={900}
            open={visible}
            ToggleLightBox={(e) => dispatch(actions.toggleLightBoxAction())}
            className="itinerary_daily_lightBox"
        >
            <div className={styles.lightBoxContent}>
                <h3 className={styles.title}>{Name}</h3>
                {ImgMList !== null && <Carousel />}
                {Introduction && <Intro />}
                <Poi />
            </div>
        </LightBox>
    );
};

export default ItineraryDailyLightbox;
